import { useEffect, useState } from 'react';
import instance from '../api/axios/utils.ts/instance';
import { ApiResponse } from '../constants/types';

// 바로가기 메뉴 (뷰어 세그먼트에 맞춰 노출 순서대로 내려온다)
export interface QuickMenu {
  id: number;
  name: string;
  iconUrl: string;
  linkUrl: string;
  linkType: 'NONE' | 'NEW_TAB' | 'SAME_TAB';
  audience: string;
  isLinkActive: boolean;
}

// 조회 실패 또는 빈 응답일 때 사용하는 기본 메뉴
const FALLBACK_MENUS: QuickMenu[] = [
  ['코스 찾기', 'findacourse', '/courses'],
  ['SHOP', 'shop', '/shop'],
  ['내 학습\n(교사대학)', 'mylearning', '/learning'],
  ['클래스 관리', 'classmanagement', '/ClassManagement'],
  ['교인인증', 'churchmembercerti', '/mypage/membership'],
  ['커뮤니티', 'mybadge', '/community'],
  [
    '교재 음원',
    'music',
    'https://jebs-notice.oopy.io/07c226c9-0104-4699-9427-f7d4c6a06134',
  ],
  [
    '주변 클래스',
    'classarroundme',
    'https://cafe.naver.com/f-e/cafes/27682530/menus/73?t=1767578070294',
  ],
].map(
  ([name, icon, linkUrl], i): QuickMenu => ({
    id: -(i + 1),
    name,
    iconUrl: `${process.env.PUBLIC_URL}svg/home/${icon}.svg`,
    linkUrl,
    linkType: linkUrl.startsWith('http') ? 'NEW_TAB' : 'SAME_TAB',
    audience: 'ALL',
    isLinkActive: true,
  }),
);

/**
 * 노출 중인 바로가기 메뉴 목록 조회
 * 기본 메뉴로 시작해 응답이 오면 교체한다.
 * 조회 실패 또는 빈 응답이면 기본 메뉴를 그대로 유지한다.
 */
export const useQuickMenus = () => {
  const [menus, setMenus] = useState<QuickMenu[]>(FALLBACK_MENUS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    instance
      .get<ApiResponse<QuickMenu[]>>('/v1/quick-menus')
      .then(({ data }) => {
        if (alive && data.data?.length) setMenus(data.data);
      })
      .catch((err) => console.error('바로가기 메뉴 조회 실패', err))
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  return { menus, loading };
};
